import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "collapse-inner" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    css: $options.use_css,
    name: $props.name,
    class: "group",
    tag: "div",
    duration: $props.duration
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id || item,
          class: "item"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {
              item: item,
              index: idx
            }, undefined, true)
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["css", "name", "duration"]))
}